import { BENCHED } from './definitions'

type PositionTileDragProps = {
	allowDrag: boolean
	isAvailable: boolean
	position: string | undefined
	endPosition: string
	isLocked: boolean
	isNullPosition: boolean
}

export function canDragPositionTile(props: PositionTileDragProps) {
	return props.allowDrag && (
		props.isAvailable ||
		props.position !== BENCHED ||
		props.endPosition !== BENCHED ||
		props.isLocked ||
		props.isNullPosition
	)
}
